import { Component } from "react";
import Logo from "../asset/images/Logo.png"
import { GoRocket } from "react-icons/go";
import { Link } from "react-router-dom";

class Footer extends Component {
    state = {
        user: []
    }
    componentDidMount() {
        const savedUser = localStorage.getItem("teslaUserInfo");
        // const accessToken = localStorage.getItem("teslaUserAccessToken");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            this.setState({
                user: {
                    firstName: userData.firstName || "",
                    lastName: userData.lastName || "",
                    userPlan: userData.userPlan || ""
                }
            });
        }
    }


    render() {
        const {user} = this.state
        const isLoggedIn = user && Object.keys(user).length > 0;
        return (
            <footer className="landing_footer">
                <div className="footer_container">
                    <section className="list_container">
                        <img src={Logo} alt="logo" className="logo" />
                    </section>
                    <section className="list_container">
                        <li className="head">Our Company</li>
                        <Link to={isLoggedIn ? "/Dashboard" : "/signup"}><li>Get Started</li></Link>
                        <Link to={isLoggedIn ? "/Dashboard" : "/login"}><li>Sign in</li></Link>
                        <Link to={isLoggedIn ? "/Dashboard" : "/login"}><li>Upgrade</li></Link>
                    </section>
                    <section className="list_container">
                        <h3>Subscribe To Trading Update</h3>
                        <form>
                            <input />
                            <button><GoRocket /></button>
                        </form>
                        <p>Sign up for our latest news & articles. We won’t give you spam mails.</p>
                    </section>
                </div>
                <div className="footer_policy">
                    <p>© 2012 , Tesla Safe Trade . All Rights Reserved.</p>
                </div>
            </footer>
        )
    }
}


export default Footer